import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import HttpError from './error'


// let show=true
let vm = new Vue()
axios.defaults.withCredentials = true
const instance = axios.create({
  // baseURL: "/api",
  baseURL:process.env.VUE_APP_BASE_URL,
  // baseURL:'https://zi72ik.39nat.com',
  timeout: 300000,
  // headers:{'satoken':'868d18e2-db41-4370-b63d-dbcfa5e0c949'}
})

instance.interceptors.request.use(config => {
  // console.log(config)
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})
let showError = true
instance.interceptors.response.use(response => {
  // console.log(123123123, response)
  if (response.data.code == 10002) {
    if (showError) {
      vm.msg.error("Session过期，请重新登录!")
      showError = false
      sessionStorage.setItem("login", false);
      // 清除session
      sessionStorage.removeItem("orgName");
      sessionStorage.removeItem("orgId");
      // sessionStorage.removeItem("username");
      // sessionStorage.removeItem("headImg");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("privileges");
      // sessionStorage.removeItem("sysTab");
      // sessionStorage.removeItem("sysStartTime");
      sessionStorage.removeItem("loginName");
      sessionStorage.removeItem("nickName");
      sessionStorage.removeItem("tenant");
      router.replace('/login')
      return
    }
  }
  return response

}, error => {
  return Promise.reject(error)
})



/* instance.interceptors.response.use(response => {
    // console.log(response)
    if(response.status !== 200){
        HttpError(response.status)
    }
    // session过期
    if (response.data.code== 10002) {
      if (show) {
        show = false;
        sessionStorage.setItem("login", false);
        // 清除session
        sessionStorage.removeItem("orgName");
        sessionStorage.removeItem("orgId");
        // sessionStorage.removeItem("username");
        // sessionStorage.removeItem("headImg");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("privileges");
        // sessionStorage.removeItem("sysTab");
        // sessionStorage.removeItem("sysStartTime");
        // sessionStorage.removeItem("modelId");
        sessionStorage.removeItem("loginName");
        sessionStorage.removeItem("nickName");
        sessionStorage.removeItem("tenant");
        console.log(vm.msg);
        vm.msg.warn("Session过期，请重新登录!")
        router.push('/login');
        return;
      }
    } else {
      show = true;
    }
    return response
    
}, error => {
    console.log(error)
    return Promise.reject(error)
})
 */
export default {
  delete(url, params) {
    return new Promise((resolve, reject) => {
      instance.delete(url, {
        params: params
      }).then(res => {
        // console.log(res);
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  get(url, params) {
    let paramsData = Object.assign({
      r: new Date().getTime()
    }, params)
    return new Promise((resolve, reject) => {
      instance.get(url, {
        params: paramsData
      }).then(res => {
        // console.log(res);
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  getBlob(url, params) {
    return new Promise((resolve, reject) => {
      instance({
        url,
        method: 'get',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        // console.log(res);
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })

    })
  },
  post(url, params) {
    return new Promise((resolve, reject) => {
      instance.post(url, params)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  postParamsData(url, params, data) {
    let datas = data ? data : null
    return new Promise((resolve, reject) => {
      instance({
          url,
          method: 'post',
          data: datas,
          params: params,
        }).then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  postFormData(url, params) {
    return new Promise((resolve, reject) => {
      instance({
          transformRequest: [function (data) { // 在请求之前对data传参进行格式转换
            return qs.stringify(data);
          }],
          url,
          method: 'post',
          data: params,
        }).then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  postFormJsonData(url, params) {
    return new Promise((resolve, reject) => {
      instance({
          url,
          method: 'post',
          data: params,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  postParamsForm(url, params, data) {
    let datas = data ? data : (new FormData());
    return new Promise((resolve, reject) => {
      instance({
          url,
          method: 'post',
          data: datas,
          params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  put(url, params, data) {
    return new Promise((resolve, reject) => {
      instance({
          url,
          method: 'put',
          params: params,
          data: data || {}
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  putParamsData(url, params, data) {
    let datas = data ? data : null
    return new Promise((resolve, reject) => {
      instance({
          url,
          method: 'put',
          data: datas,
          params: params,
        }).then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  putFormData(url, params) {
    return new Promise((resolve, reject) => {
      instance({
          transformRequest: [function (data) { // 在请求之前对data传参进行格式转换
            return qs.stringify(data);
          }],
          url,
          method: 'put',
          data: params
        }).then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  putParamsForm(url, params, data) {
    return new Promise((resolve, reject) => {
      instance({
          url,
          method: 'put',
          data: data,
          params: params,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}